import z from "zod";

export const categorySchema = z.object({
  id: z.number().min(0, { message: "ID must be a positive number." }),
  name: z
    .string()
    .min(1, { message: "Name must be 1-100 characters long." })
    .max(100, { message: "Name must be 1-100 characters long." }),
});
